import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "resource-share-container" }
const _hoisted_2 = { class: "sub-menu-chiplet resource-menu-share" }
const _hoisted_3 = {
  key: 0,
  class: "pdf-container"
}
const _hoisted_4 = {
  key: 1,
  class: "audio-container"
}
const _hoisted_5 = {
  key: 2,
  class: "iframe-container"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_pdf_viewer = _resolveComponent("pdf-viewer")!
  const _component_audio_player = _resolveComponent("audio-player")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, {
      translucent: "",
      class: "resource-viewer-toolbar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          class: "modal-toolbar",
          mode: "md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("messages.application.close")) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      src: _ctx.close,
                      style: {"font-size":"20px"}
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_icon, {
              class: "chiplet-icon",
              icon: _ctx.shareSocial,
              mode: "md",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleShareResource()))
            }, null, 8, ["icon"])
          ])
        ], 512), [
          [_vShow, _ctx.showShareIcon]
        ]),
        (_ctx.resource.MimeType === 'application/pdf')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_pdf_viewer, {
                src: `${_ctx.resourceData}`,
                style: {"height":"100%","width":"100%","margin-top":"10px"}
              }, null, 8, ["src"])
            ]))
          : (_ctx.isAudio)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.resource.Name), 1),
                _createVNode(_component_ion_icon, {
                  icon: _ctx.musicalNotes,
                  style: {"font-size":"200px","color":"var(--ion-color-dark)","margin-bottom":"10px"}
                }, null, 8, ["icon"]),
                _createVNode(_component_audio_player, {
                  "audio-data": `${_ctx.resourceData}`,
                  "start-time-seconds": 0,
                  "end-time-seconds": 0,
                  class: _normalizeClass('no-nav'),
                  color: "--color-primary"
                }, null, 8, ["audio-data"])
              ]))
            : (_ctx.resource.MimeType === 'text/html' || 'text/x-uri')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("iframe", {
                    src: `${_ctx.resource.Url}`,
                    width: "100%",
                    height: "100%",
                    frameborder: "0",
                    marginheight: "0",
                    marginwidth: "0"
                  }, " Loading Form... ", 8, _hoisted_6)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.resource?.MimeType), 1))
      ]),
      _: 1
    })
  ], 64))
}